import RecepcionDeMercaderiaPagina from "./RecepcionDeMercaderiaPagina";

export default RecepcionDeMercaderiaPagina;